// Web Vitals: coleta LCP/CLS/INP/FCP/TTFB e despacha pro destino configurado.
// Em dev, console. Em prod, beacon pro Sentry (readme §13, §14).
import { onCLS, onLCP, onINP, onFCP, onTTFB, type Metric } from 'web-vitals';
import { env } from '@/config/env';

function sendToAnalytics(metric: Metric) {
  if (env.VITE_DEV) {
    // eslint-disable-next-line no-console
    console.info('[vitals]', metric.name, Math.round(metric.value), metric.rating);
    return;
  }
  // TODO: beacon pra Sentry quando DSN configurada — Fase 1.
}

export function setupVitals(): void {
  onCLS(sendToAnalytics);
  onLCP(sendToAnalytics);
  onINP(sendToAnalytics);
  onFCP(sendToAnalytics);
  onTTFB(sendToAnalytics);
}
